import { defineComponent, ExtractPropTypes, toRefs } from 'vue';
import { createNamespaceBem } from '@/utils';
import { RouteLocationRaw } from 'vue-router';

interface ISingleLineCardsProps {
  title?: string;
  icon?: string;
  subTitle?: string;
  showArrow?: boolean;
  className?: string;
  flag?: string;
  routerParams?: RouteLocationRaw;
}

export type SingleLineCardsProps = ExtractPropTypes<ISingleLineCardsProps>;

const { bem } = createNamespaceBem('single-line-cards');

export default defineComponent({
  props: {
    list: {
      type: Array<ISingleLineCardsProps>,
      default: () => {
        return [];
      },
    },
  },
  setup(props, ctx) {
    const { list } = toRefs(props);
    const handleTapCard = (cardData) => {
      ctx.emit('onClickCard', cardData);
    };
    return () => {
      if (list?.value.length) {
        return (
          <div class={bem('box')}>
            {list.value.map((cardData, index) => (
              <div class={[bem('box__card'), cardData.className]} key={index} onClick={() => handleTapCard(cardData)}>
                <img src={cardData.icon} class={bem('box__card__icon')} />
                <div class={bem('box__card__title')}>
                  {cardData.title}
                  <div>{cardData.subTitle}</div>
                </div>
                {cardData.showArrow && <div class={bem('box__card__arrow')}></div>}
              </div>
            ))}
          </div>
        );
      }
      return null;
    };
  },
});
